import { React, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import { Brightness4, ExpandLess, ExpandMore } from '@mui/icons-material';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import InventoryIcon from '@mui/icons-material/Inventory';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import MenuIcon from '@mui/icons-material/Menu';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SchoolIcon from '@mui/icons-material/School';
import StoreIcon from '@mui/icons-material/Store';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { AppBar, Collapse, Container, Drawer, Hidden, ListItemButton, ListItemIcon, ListItemText, Tooltip, useMediaQuery } from '@mui/material';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Profile from '../appBar/profile';
import MenuSistema from '../home/menu-sistemas';
import AuthService from '../service';
import { ifAnyGranted } from '../auth';
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import AlertNotification from '../component/generic/AlertNotification';

const PREFIX = 'Layout'
const DRAWER_WIDTH = 240

const classes = {
  root: `${PREFIX}-root`,
  toolbar: `${PREFIX}-toolbar`,
  toolbarOpen: `${PREFIX}-toolbar-open`,
  toolbarIcon: `${PREFIX}-toolbarIcon`,
  appBar: `${PREFIX}-appBar`,
  appBarShift: `${PREFIX}-appBarShift`,
  menuButton: `${PREFIX}-menuButton`,
  menuButtonHidden: `${PREFIX}-menuButtonHidden`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  drawerPaperClose: `${PREFIX}-drawerPaperClose`,
  appBarSpacer: `${PREFIX}-appBarSpacer`,
  content: `${PREFIX}-content`,
  container: `${PREFIX}-container`,
  paper: `${PREFIX}-paper`,
  fixedHeight: `${PREFIX}-fixedHeight`
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
  },

  [`& .${classes.toolbar}`]: {
    paddingRight: 24,
  },

  [`& .${classes.toolbarOpen}`]: {
    paddingLeft: 0,
  },

  [`& .${classes.toolbarIcon}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },

  [`& .${classes.appBar}`]: {
    zIndex: theme.zIndex.appBar,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  [`& .${classes.appBarShift}`]: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    [theme.breakpoints.up('sm')]: {
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
    },
  },

  [`& .${classes.menuButton}`]: {
    //marginRight: 26,
  },

  [`& .${classes.menuButtonHidden}`]: {
    display: 'none',
  },

  [`& .${classes.drawerPaper}`]: {
    zIndex: 1100,
    position: 'relative',
    whiteSpace: 'nowrap',
    width: DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    borderRight: "0"
  },

  [`& .${classes.drawerPaperClose}`]: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },

  [`& .${classes.appBarSpacer}`]: {
  },

  [`& .${classes.content}`]: {
    flexGrow: 1,
    minHeight: '100vh',
    overflow: 'auto',

    backgroundColor: theme.palette.mode === 'light' ? '#F5F5F5' : '#1b252d'
  },

  [`& .${classes.container}`]: {
    paddingTop: 18,
    paddingInline: "10px"
  },

  [`& .${classes.paper}`]: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },

  [`& .${classes.fixedHeight}`]: {
    height: 240,
  }
}))


const StatusRedis = (props) => {
  const service = new AuthService()
  const [status, setStatus] = useState()

  useEffect(() => {
    service.get('/redis/status', []).then(result => setStatus(result)).catch(err => console.log(err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      Status do cache: {status}
    </Typography>
  );
}



export function Layout() {

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))
  const dispatch = useDispatch()
  const navigate = useNavigate()
  //const [open, setOpen] = useState(!isMobile)
  const [open, setOpen] = useState(localStorage.getItem('_side_panel_') ? localStorage.getItem('_side_panel_') === "true" : true)
  const [loading, setLoading] = useState(true)

  const [openFranchise, setOpenFranchise] = useState(false)
  const [openPerformance, setOpenPerformance] = useState(false)
  const [openAudit, setOpenAudit] = useState(false)
  const isAdmin = ifAnyGranted('ROLE_ADMIN')

  const toggleFranchise = () => {
    setOpenFranchise(!openFranchise)
  }

  const togglePerformance = () => {
    setOpenPerformance(!openPerformance)
  }

  const toggleAudit = () => {
    setOpenAudit(!openAudit)
  }

  useEffect(() => {
    const service = new AuthService()

    service.get('/verify-session').then(async () => {
      const token = AuthService.getToken()
      await service.load(token)
    }).catch(err => {
      console.log(err)
      if (err?.response?.status === 401) {
        handleLogout()
      }
    }).finally(() => setLoading(false))
  }, [])



  const toggleThemeMode = () => {
    dispatch({ type: 'TOGGLE_THEME_MODE' })
  }

  function handleLogout() {
    // Limpa o localStorage ANTES do dispatch: o reducer de LOGOUT_USER recria o
    // dashboardFilter, que restauraria as unidades salvas se a chave ainda existisse.
    localStorage.removeItem('id_token')
    localStorage.removeItem('_profile')
    localStorage.removeItem('filter_bi')
    localStorage.removeItem('filter_bi_unidades')
    // Conversa da Sisa tem dado de negócio da unidade — não pode sobrar após logout.
    localStorage.removeItem('chat_sisa_conversa')

    dispatch({ type: 'LOGOUT_USER' })

    navigate('/login')
  }

  function handleRoute(route) {
    navigate(route)
  }
  const handleDrawerOpen = () => {
    setOpen(true)
    localStorage.setItem('_side_panel_', true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
    localStorage.setItem('_side_panel_', false)
  }

  return (
    <Root className={classes.root}>

      <CssBaseline />

      <AppBar
        position="absolute" open={open} elevation={0}
        className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar
          className={clsx(classes.toolbar, open && classes.toolbarOpen)}>

          {open && (
            <IconButton onClick={handleDrawerClose} size="large" color="inherit">
              <ChevronLeftIcon />
            </IconButton>
          )}

          <IconButton
            edge="start"
            color="inherit"
            aria-label="Abrir menu"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
            size="large">
            <MenuIcon />
          </IconButton>



          <Typography
            noWrap
            variant="h4"
            component="h1"
            color="inherit"
            sx={{ flexGrow: 1 }}
            align='left'
          >
            Sischef Analytics
          </Typography>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <AlertNotification />

            <Tooltip disableInteractive title="Programa de benefícios">
              <IconButton href="https://sischef.com/programa-de-beneficios/" target="_blank" size="large" color="inherit">
                <EmojiEventsIcon />
              </IconButton>
            </Tooltip>

            <Tooltip disableInteractive title="Conheça nosso EAD">
              <IconButton href="https://www.sympla.com.br/play/ensina-sischef-2-0/3314890" target="_blank" size="large" color="inherit">
                <SchoolIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Tooltip disableInteractive title="Converse com um atendente">
            <IconButton href={`${process.env.REACT_APP_PDV_URL}/helpdesk`} target="_blank" size="large" color="inherit">
              <Badge color="warning" overlap="circular" badgeContent=" " variant="dot">
                <HeadsetMicIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <IconButton color="inherit" onClick={() => toggleThemeMode()} size="large">
            <Brightness4 />
          </IconButton>

        </Toolbar>
      </AppBar>

      <Drawer
        variant={isMobile ? "temporary" : "permanent"} open={open} elevation={0}
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        onClose={handleDrawerClose}>

        {!isMobile ? (
          <Toolbar disableGutters>
            {open && <MenuSistema />}
          </Toolbar>
        ) : (open && <MenuSistema />)}

        {open && <Profile />}

        <List component="nav">
          <ListItemButton onClick={() => handleRoute('/')}>
            <ListItemIcon><AccessTimeIcon /></ListItemIcon>
            <ListItemText primary="Em tempo real" />
          </ListItemButton>

          <ListItemButton onClick={() => handleRoute('/sales')}>
            <ListItemIcon><PointOfSaleIcon /></ListItemIcon>
            <ListItemText primary="Vendas" />
          </ListItemButton>

          {/* 
            <ListItemButton disabled onClick={() => handleRoute('/financial')}>
                <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
                <ListItemText primary="Financeiro" />
            </ListItemButton> 
          */}

          <ListItemButton onClick={() => handleRoute('/product')}>
            <ListItemIcon><InventoryIcon /></ListItemIcon>
            <ListItemText primary="Produto" />
          </ListItemButton>

          <ListItemButton onClick={() => handleRoute('/customer')}>
            <ListItemIcon><RecentActorsIcon /></ListItemIcon>
            <ListItemText primary="Cliente" />
          </ListItemButton>

          {/* Auditoria (submenu) */}
          <ListItemButton onClick={toggleAudit}>
            <ListItemIcon><KeyboardCommandKeyIcon /></ListItemIcon>
            <ListItemText primary="Auditoria" />
            {openAudit ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openAudit} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={() => handleRoute('/checking')}>
                <ListItemIcon><RemoveShoppingCartIcon /></ListItemIcon>
                <ListItemText primary="Itens cancelados" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={() => handleRoute('/orderIntegration')}>
                <ListItemIcon><SyncProblemIcon /></ListItemIcon>
                <ListItemText primary="Pedidos não importados" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={() => handleRoute('/paymentExclusion')}>
                <ListItemIcon><CreditCardOffIcon /></ListItemIcon>
                <ListItemText primary="Exclusões de pagamentos" />
              </ListItemButton>
            </List>
          </Collapse>

          {/* Performance (submenu) */}
          <ListItemButton onClick={togglePerformance}>
            <ListItemIcon><TrendingUpIcon /></ListItemIcon>
            <ListItemText primary="Performance" />
            {openPerformance ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openPerformance} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={() => handleRoute('/franchise')}>
                <ListItemIcon><StoreIcon /></ListItemIcon>
                <ListItemText primary="das unidades" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={() => handleRoute('/performanceOperation')}>
                <ListItemIcon><ViewTimelineIcon /></ListItemIcon>
                <ListItemText primary="da operação" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton onClick={() => handleRoute('/reports')}>
            <ListItemIcon><AssessmentIcon /></ListItemIcon>
            <ListItemText primary="Relatórios" />
          </ListItemButton>

          <ListItemButton onClick={handleLogout}>
            <ListItemIcon><ExitToAppIcon /></ListItemIcon>
            <ListItemText primary="Sair" />
          </ListItemButton>

          <Divider />

          {open && !loading && <StatusRedis sx={{ pt: 2 }} />}

          {isAdmin && (
            <ListItemButton onClick={() => handleRoute('/admin/cache')}>
              <ListItemIcon><DeleteSweepIcon /></ListItemIcon>
              <ListItemText primary="Gerenciar cache" />
            </ListItemButton>
          )}
        </List>
      </Drawer>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />

        <Container maxWidth={false} className={classes.container}>
          {loading ? (
            <Box pt={8}>
              <Typography>😎 Carregando o Analytics...</Typography>
            </Box>
          ) : (
            <Outlet />
          )}
        </Container>
      </main>

    </Root>
  )
}